import { useLocation, useNavigate } from 'react-router';
import {
  makeStyles,
  Toolbar,
  ToolbarButton,
  ToolbarDivider
} from '@fluentui/react-components';
import AuthButton from './AuthButton';
import AlertHealthIndicator from './AlertHealthIndicator';

const useStyles = makeStyles({
  root: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '5px',
  },
  left: {
    display: 'flex',
    alignItems: 'center',
    paddingLeft: '12px',
  },
});

export default function Header({ alertConnected }) {
  const navigate = useNavigate();
  const location = useLocation();
  const styles = useStyles();
  const currentPage = location.pathname;
  const isLive = currentPage === '/live';

  const params = {
    '/live': {
      handleSwitch: () => navigate('/report'),
      buttonText: 'Rapport R&D'
    },
    '/report': {
      handleSwitch: () => navigate('/live'),
      buttonText: 'Rapport Temps Réel'
    }
  };

  const {handleSwitch, buttonText} = params[currentPage];

  return (
    <div className={styles.root}>
      <div className={styles.left}>
        {isLive && alertConnected != null && (
          <AlertHealthIndicator isConnected={alertConnected} />
        )}
      </div>
      <Toolbar size="small">
        <ToolbarButton
          onClick={handleSwitch}
          appearance="secondary"
        >
          {buttonText}
        </ToolbarButton>
        <ToolbarDivider className={styles.negateRightMargin}/>
        <AuthButton />
      </Toolbar>
    </div>
  );
};
